import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import KYCVerification from './pages/KYCVerification';
import Merchants from './pages/Merchants';
import Transactions from './pages/Transactions';
import ActivityLog from './pages/ActivityLog';
import Settings from './pages/Settings';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/users" element={
        <ProtectedRoute requiredPermission="users">
          <Users />
        </ProtectedRoute>
      } />
      <Route path="/kyc" element={
        <ProtectedRoute requiredPermission="kyc">
          <KYCVerification />
        </ProtectedRoute>
      } />
      <Route path="/merchants" element={
        <ProtectedRoute requiredPermission="merchants">
          <Merchants />
        </ProtectedRoute>
      } />
      <Route path="/transactions" element={
        <ProtectedRoute requiredPermission="transactions">
          <Transactions />
        </ProtectedRoute>
      } />
      <Route path="/activity-log" element={
        <ProtectedRoute requiredPermission="activity-log">
          <ActivityLog />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute requiredPermission="settings">
          <Settings />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
